export const getStoreName = () => ({
  type: 'GET_STORE_NAME',
});

export const updateProduct = productData => ({
  type: 'UPDATE_PRODUCT',
  payload: productData,
});
